module.exports = __webpack_public_path__ + "img/roof_window.d104f2e.svg";